// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-background {
  width: 100%;
  height: 100%;
  --amount: 100;
}

.svg-background span {
  width: 3vmin;
  height: 6vmin;
  border-radius: 3vmin;
  backface-visibility: hidden;
  position: absolute;
  animation-name: move;
  animation-timing-function: cubic-bezier(0.4, 0, 1, 0.8);
  animation-iteration-count: infinite;
  animation-duration: 3s;
  top: calc(50% - 3vmin);
  left: 50%;
  transform-origin: -3vmin center;
}
.svg-background span:nth-child(1) {
  background: #02bfff;
  animation-delay: -0.5s;
  opacity: 0;
}
.svg-background span:nth-child(2) {
  background: #7db7cc;
  animation-delay: -1s;
  opacity: 0;
}
.svg-background span:nth-child(3) {
  background: #7db7cc;
  animation-delay: -1.5s;
  opacity: 0;
}
.svg-background span:nth-child(4) {
  background: #02bfff;
  animation-delay: -2s;
  opacity: 0;
}
.svg-background span:nth-child(5) {
  background: #7db7cc;
  animation-delay: -2.5s;
  opacity: 0;
}
.svg-background span:nth-child(6) {
  background: #19608f;
  animation-delay: -3s;
  opacity: 0;
}

@keyframes move {
  0% {
    transform: scale(1) rotate(0deg) translate3d(0, 0, 1px);
  }
  30% {
    opacity: 1;
  }
  100% {
    z-index: 10;
    transform: scale(0) rotate(360deg) translate3d(0, 0, 1px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/LoadingSvg2.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAAF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,oBALe;EAMf,2BAAA;EACA,kBAAA;EACA,oBAAA;EACA,uDAAA;EACA,mCAAA;EACA,sBAbkB;EAclB,sBAAA;EACA,SAAA;EACA,+BAAA;AAJF;AAaI;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AAXN;AAQI;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AANN;AAGI;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AADN;AAFI;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAIN;AAPI;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AASN;AAZI;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAcN;;AATA;EACE;IACE,uDAAA;EAYF;EATA;IACE,UAAA;EAWF;EARA;IACE,WAAA;IACA,yDAAA;EAUF;AACF","sourcesContent":["// This class will be stored in npm cache - run npm cache clear --force for every change made to this file\n.svg-background {\n  width: 100%;\n  height: 100%;\n  --amount: 100;\n}\n\n$animationDuration: 3s;\n$amount: 6;\n$particleRadius: 3vmin; // size of loader circle\n\n.svg-background span {\n  width: $particleRadius * 1;\n  height: $particleRadius * 2;\n  border-radius: $particleRadius;\n  backface-visibility: hidden;\n  position: absolute;\n  animation-name: move;\n  animation-timing-function: cubic-bezier(0.4, 0, 1, 0.8);\n  animation-iteration-count: infinite;\n  animation-duration: $animationDuration;\n  top: calc(50% - #{$particleRadius});\n  left: 50%;\n  transform-origin: ($particleRadius*-1) center;\n\n  $colors: (\n    #19608f,\n    #02bfff,\n    #7db7cc,\n  );\n\n  @for $i from 1 through $amount {\n    &:nth-child(#{$i}) {\n      background: nth($colors, random(length($colors)));\n      animation-delay: calc($i/$amount) * $animationDuration * -1;\n      opacity: 0;\n    }\n  }\n}\n\n@keyframes move {\n  0% {\n    transform: scale(1) rotate(0deg) translate3d(0, 0, 1px);\n  }\n\n  30% {\n    opacity: 1;\n  }\n\n  100% {\n    z-index: 10;\n    transform: scale(0) rotate(360deg) translate3d(0, 0, 1px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
